import React from 'react';
import { Badge, useTheme } from '@mui/material';
import { BiGhost } from 'react-icons/bi';
import { DrawerButton } from '.';

type Props = {
  incomingGhostChallenges: number;
  handleGhostChallengesView: () => void;
};
export const DrawerButtonGhost = ({
  handleGhostChallengesView,
  incomingGhostChallenges,
}: Props) => {
  const theme = useTheme();

  return (
    <DrawerButton
      variant="contained"
      onClick={handleGhostChallengesView}
      sx={{
        width: 40,
        marginX: 1,
        height: '100%',
        border: `1px solid ${theme.palette.primary.dark}`,
        borderBottom: 'none',
      }}
    >
      <Badge
        badgeContent={incomingGhostChallenges}
        color="warning"
        sx={{
          '& .MuiBadge-badge': {
            width: 25,
            height: 25,
            fontSize: 20,
            marginTop: '-5px',
            marginRight: '-5px',
          },
        }}
      >
        <BiGhost
          size={32}
          style={{
            color: theme.palette.primary.main,
          }}
        />
      </Badge>
    </DrawerButton>
  );
};
